import { render, staticRenderFns } from "./StockInvoiceShow.vue?vue&type=template&id=2fbea3b4&scoped=true&"
import script from "./StockInvoiceShow.vue?vue&type=script&lang=js&"
export * from "./StockInvoiceShow.vue?vue&type=script&lang=js&"
import style0 from "./StockInvoiceShow.vue?vue&type=style&index=0&id=2fbea3b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbea3b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
